// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2-xeO","notes":"Notes_notes__3bXu9","note":"Notes_note__XZBxq","markdown":"Notes_markdown__3RKOl"};